import React, { Fragment, useState, useEffect, useRef } from "react";
import VolumeRed from "./VolumeRed";

const LiveMentorsFeature = () => {
  const videoRef = useRef(null);
  const [duration, setDuration] = useState(0);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);
  return (
    <Fragment>
      <div className="current-feature">
        <img
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/img/mentor-stream.jpg"
          }
          className="live-image-container"
        />
        <div className="middle-container red">
          <div className="stream-content">
            <div className="top-video-overlay">
              <div className="user-overlay-info">
                <div className="top-user-avi-container">
                  <div className="streamer-user-avi"></div>
                </div>
                <div className="helper-container">
                  <div className="stream-description-alt">
                    <p className="stream-username-title">
                      <span className="red mr-5 description-font">
                        FirstName
                      </span>
                      <span className="red mr-10 description-font">
                        LastName
                      </span>
                      <span className="white description-font-alt">
                        Job Title
                      </span>
                    </p>
                    <p className="stream-p-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                  </div>
                </div>
              </div>
              <div className="video-stream-live red">
                <i className="fas fa-circle mx-5"></i>
                Live
              </div>
              <div className="alt-left-controls">
                <ul className="controls">
                  <VolumeRed
                    className="Rac__volume"
                    initial={0}
                    onChange={(level) => {
                      const volume = level / 100;
                      videoRef.current.volume = volume;
                      videoRef.current.muted = volume === 0;
                    }}
                  />
                </ul>
              </div>
              <div className="watch-stream">
                <button className="watch-stream-button background-red">
                  Watch
                </button>
              </div>
              <div className="stream-viewers-right white">
                <i className="fas fa-user mx-5"></i>
                82.7k
              </div>
            </div>
            <video
              ref={videoRef}
              muted={true}
              src={
                "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/yoga_class.mp4"
              }
              autoPlay={true}
              loop={true}
              className="top-stream-video fill-video"
            ></video>
          </div>
        </div>
        <img
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/img/mentor-stream.jpg"
          }
          className="live-image-container"
        />
      </div>
    </Fragment>
  );
};

export default LiveMentorsFeature;
